module.exports = __webpack_public_path__ + "assets/img/goods-distribution.ec4ceffc.png";